export function getImageDimensions(
  source: File | string,
): Promise<{ width: number; height: number } | undefined> {
  if (
    typeof source !== "string" &&
    (!source.type.startsWith("image/") || source.type === "image/svg+xml")
  ) {
    return Promise.resolve(undefined);
  }

  return new Promise((resolve) => {
    const url = typeof source === "string" ? source : URL.createObjectURL(source);
    const img = new Image();
    const cleanup = () => {
      if (typeof source !== "string") URL.revokeObjectURL(url);
    };
    img.onload = () => {
      cleanup();
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => {
      cleanup();
      resolve(undefined);
    };
    img.src = url;
  });
}
